import {request, makePath} from './http';
const API_NAME = 'audit-log';

export function getAuditLogs(clientId, params = {}) {
  return request('GET',makePath(API_NAME), {clientId,params});
}
